'use client'

import { useId } from 'react'

import cn from 'clsx'
import { HyperLink, type HyperLinkProps } from '@/components/hyper-link/hyper-link'
import { Button } from '@/components/Button/Button'
import { ChevronRight, Article } from '@doist/icons/brand'

import css from './resource-link.module.css'

export interface ResourceLinkProps
    extends Omit<HyperLinkProps, 'bold' | 'children' | 'weight' | 'borderRadius'> {
    /** The link to the blog post. */
    href: string
    /** The blog post title */
    title: string
    /** Callout copy */
    calloutText: string
}

export function ResourceLink({ title, href, className, calloutText }: ResourceLinkProps) {
    const ctaID = useId()

    return (
        <div className={cn([css.twistBlogCard, className])}>
            <div className={css.icon}>
                <Article width={16} height={16} aria-hidden />
            </div>
            <div className={css.content}>
                <HyperLink
                    className={css.blogCardAnchor}
                    href={href}
                    target="_blank"
                    size="minor-lg"
                    aria-describedby={ctaID}
                >
                    {title}
                </HyperLink>
                {calloutText && (
                    <Button
                        id={ctaID}
                        className={css.ctaButton}
                        variant="tertiary"
                        endIcon={ChevronRight}
                        tabIndex={-1}
                        aria-hidden
                    >
                        {calloutText}
                    </Button>
                )}
            </div>
        </div>
    )
}
